import { IconProps } from "./interfaces/IconProps.interface"

const CheckBoxMultipleFill = (props: IconProps) => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M4.08268 4.08268V1.74935C4.08268 1.59464 4.14414 1.44627 4.25354 1.33687C4.36293 1.22747 4.51131 1.16602 4.66602 1.16602H12.2493C12.4041 1.16602 12.5524 1.22747 12.6618 1.33687C12.7712 1.44627 12.8327 1.59464 12.8327 1.74935V9.33268C12.8327 9.48739 12.7712 9.63577 12.6618 9.74516C12.5524 9.85456 12.4041 9.91602 12.2493 9.91602H9.91602V12.2453C9.91602 12.5696 9.6541 12.8327 9.3286 12.8327H1.75343C1.67627 12.8328 1.59985 12.8176 1.52855 12.7881C1.45724 12.7586 1.39246 12.7154 1.3379 12.6608C1.28333 12.6062 1.24007 12.5415 1.21057 12.4701C1.18108 12.3988 1.16594 12.3224 1.16602 12.2453L1.16777 4.6701C1.16777 4.34577 1.42968 4.08268 1.75518 4.08268H4.08268ZM5.24935 4.08268H9.3286C9.65293 4.08268 9.91602 4.3446 9.91602 4.6701V8.74935H11.666V2.33268H5.24935V4.08268ZM4.95943 10.4993L8.25877 7.19943L7.43393 6.3746L4.95943 8.84968L3.72102 7.61185L2.89618 8.43668L4.95943 10.4993Z"
                fill="white"
            />
        </svg>
    )
}

export default CheckBoxMultipleFill
